module.exports = __webpack_public_path__ + "static/media/Blog01.88a8d78b.jpg";